<template>
    <div
        class="vx-p-6 vx-bg-slate-300/30 vx-rounded-2xl vx-shadow-inner vx-border-solid vx-border-b vx-border-t-0 vx-border-x-0 vx-border-white vx-flex-col vx-gap-4 vx-flex"
    >
        <div>
            <div class="vx-font-bold vx-text-xs vx-text-slate-700 vx-mb-2">Favorite</div>
            <vx-box color="info" class="vx-p-4">
                <div class="vx-flex vx-flex-col vx-gap-3">
                    <div
                        v-for="favoriteOption in favoriteOptions"
                        :key="favoriteOption.value"
                        class="vx-flex vx-gap-2 vx-items-center vx-text-sm vx-cursor-pointer"
                        @click.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.space.prevent="filters.is_favorite = favoriteOption.value"
                        @keydown.enter.prevent="filters.is_favorite = favoriteOption.value"
                    >
                        <vx-radio :modelValue="filters.is_favorite === favoriteOption.value"></vx-radio>
                        {{ favoriteOption.label }}
                    </div>
                </div>
            </vx-box>
        </div>
    </div>
</template>

<script setup>
import { VxBox, VxRadio } from '@voxie/frontend-components';

const favoriteOptions = [
    { label: 'All', value: undefined },
    { label: 'Yes', value: '1' },
    { label: 'No', value: '0' },
];

const filters = defineModel({
    default: () => ({}),
});
</script>
